import React from "react";

const SupplierProgramContext = React.createContext();
SupplierProgramContext.displayName = "SupplierProgramContext";

export default SupplierProgramContext;
